import { render, staticRenderFns } from "./CustomerLimit.vue?vue&type=template&id=4ebb43e5&"
import script from "./CustomerLimit.vue?vue&type=script&lang=js&"
export * from "./CustomerLimit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLimit.vue?vue&type=style&index=0&id=4ebb43e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VMenu,VProgressCircular,VTooltip})
